// extracted by mini-css-extract-plugin
module.exports = {"liqmain":"position_liqmain__9l2DJ","posMain":"position_posMain__1I_Cv","title":"position_title__2xRv9"};